import { orchestrator } from 'satcheljs';
import { onAppPaneGroupReady } from 'owa-app-pane-group-actions';
import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import tryRunPendingAutoOpenOperation from '../utils/tryRunPendingAutoOpenOperation';

// Once the app pane group is rendered, trigger any pending auto-open operation
// This is important so that we can auto-open the pane after the container is ready
orchestrator(onAppPaneGroupReady, () => {
    if (isCapabilityEnabled(newHeaderCapability)) {
        tryRunPendingAutoOpenOperation();
    }
});
